export function formatPrice(price: number): string {
  return String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}
